import React from 'react'

const Footer = () => {
  return <footer>

    <div>
        <h1>InnovateTechSolutions</h1>
        <p>@all right reserved</p>
    </div>

    <div>
        <h5>Follow Us</h5>
        <div>
            <a href="https://www.youtube.com/" target={'black'} >Youtube</a>
            <a href="https://www.instagram.com/" target={'black'} >Instagram</a>
            <a href="https://github.com/ajaygupta001" target={'black'} >Github</a>
        </div>
    </div>


  </footer>
}

export default Footer